import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import AchievementBanner from "@/components/AchievementBanner";
import AuthCallback from "@/components/AuthCallback";

import RandomEventModal from "@/components/RandomEventModal";

import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Command from "@/pages/Command";
import Battle from "@/pages/Battle";
import WorldMap from "@/pages/WorldMap";
import Memorial from "@/pages/Memorial";
import Rebellion from "@/pages/Rebellion";
import NewGame from "@/pages/NewGame";
import Contact from "@/pages/Contact";
import Hall from "@/pages/Hall";
import Tutorial from "@/pages/Tutorial";
import BattleCardPage from "@/pages/BattleCardPage";

const Protected = ({ children }) => {
  const { auth } = useAuth();
  if (!auth) return <Navigate to="/auth" replace />;
  return children;
};

// Detect the Emergent Auth session_id fragment synchronously during render,
// BEFORE Protected routes can redirect. Must use useLocation().hash (reactive).
const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/hall" element={<Hall />} />
      <Route path="/card/battle/:id" element={<BattleCardPage />} />
      <Route path="/tutorial" element={<Protected><Tutorial /></Protected>} />
      <Route path="/command" element={<Protected><Command /></Protected>} />
      <Route path="/battle" element={<Protected><Battle /></Protected>} />
      <Route path="/world" element={<Protected><WorldMap /></Protected>} />
      <Route path="/memorial" element={<Protected><Memorial /></Protected>} />
      <Route path="/rebellion" element={<Protected><Rebellion /></Protected>} />
      <Route path="/new-game" element={<Protected><NewGame /></Protected>} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="grain min-h-screen">
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <AchievementBanner />
        <RandomEventModal />
        <Toaster theme="dark" position="top-right"
                 offset={88}
                 toastOptions={{
                   style: { background: "#0A0A0C", border: "1px solid #4A0000",
                            color: "#EAE6D7", fontFamily: "IBM Plex Mono, monospace",
                            borderRadius: 0, letterSpacing: "0.05em" }
                 }} />
      </div>
    </AuthProvider>
  );
}

export default App;
